import { render } from "./Cookies.vue?vue&type=template&id=22e4ea9e&scoped=true"
import script from "./Cookies.vue?vue&type=script&lang=js"
export * from "./Cookies.vue?vue&type=script&lang=js"

import "./Cookies.vue?vue&type=style&index=0&id=22e4ea9e&scoped=true&lang=css"

import exportComponent from "/builds/qes-dev/mirror-qes-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e4ea9e"]])

export default __exports__